import VIP from './vip';
import Tournament from './tournament';
import Invite from './invite';
import BonusZone from './bonus-zone';

export default {
    VIP,
    Tournament,
    Invite,
    BonusZone
}